import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import { DraftNote, UUID } from "@/core/types";

import { AdaptedDraftNote, adaptDraftNoteData } from "../../helpers/adapter";
import { draftNotesKeys } from "../keyFactory";
import { getDraftNotes } from "../queryFunctions/getDraftNotes";

type DraftNotesQueryOptions = UseQueryOptions<
  DraftNote[],
  unknown,
  AdaptedDraftNote[],
  ReturnType<typeof draftNotesKeys.list>
>;

function optionFactory(providerId?: UUID) {
  return {
    queryFn: () => getDraftNotes(providerId),
    queryKey: draftNotesKeys.list(providerId),
    select: adaptDraftNoteData,
  } satisfies DraftNotesQueryOptions;
}

export function useDraftNotes(providerId?: UUID) {
  return useQuery(optionFactory(providerId));
}
